import React from 'react';
import { theme } from 'antd';
import { useLocation } from 'react-router-dom';
import * as Styled from './Card.styled';

const { useToken } = theme;

interface ICardComponentProps {
  area: string;
  infoText?: string;
  icon?: React.ReactNode;
  href: string;
  textOnTop: string;
  minHeight?: string;
}

const CardComponent: React.FC<ICardComponentProps> = ({
  area,
  infoText,
  icon,
  href,
  textOnTop,
  minHeight,
}) => {
  const { token } = useToken();
  const location = useLocation();
  const showIcon = location.pathname.includes('/working_area');
  return (
    <Styled.StyledLinkButton to={href}>
      <Styled.StyledCard token={token} minHeight={minHeight}>
        <span>{textOnTop}</span>
        {showIcon && (
          <Styled.IconWrapper token={token}>{icon}</Styled.IconWrapper>
        )}
        <Styled.StyledMeta token={token} title={area} description={infoText} />
      </Styled.StyledCard>
    </Styled.StyledLinkButton>
  );
};

export default CardComponent;
